import { jsx as _jsx } from "react/jsx-runtime";
import { TreeItem2 } from '@mui/x-tree-view';
import { useNavigate } from 'react-router-dom';
import { ContainerArbitrator } from '../../../ArbitrationObjects/ContainerArbitrator/containerArbitrator';
import { NavigationSkeleton } from '../../common/NavigationSkeleton';
const debug = process.env.REACT_APP_DEBUG && false;
export const CustomerTreeItemLinkProducer = ({ label, tabName, endIcon }) => ({ contextCustomer, lastKey }) => {
    const navigate = useNavigate();
    debug && console.log(`CustomerTreeItemLinkProducer got`, contextCustomer);
    const key = lastKey + '_' + (contextCustomer ? contextCustomer.sk + '_' + tabName : tabName);
    const url = contextCustomer !== undefined ? ContainerArbitrator.getCanonicalContainerLinkForObject({ vob: contextCustomer }) : undefined;
    return url ? (_jsx(TreeItem2, { itemId: key, label: label, onClick: () => navigate(`${url}?tabName=${tabName}`), slots: { endIcon } }, key)) : (_jsx(NavigationSkeleton, {}, key));
};
